import { render } from "./Ratings2.vue?vue&type=template&id=9b629650"
import script from "./Ratings2.vue?vue&type=script&lang=js"
export * from "./Ratings2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__